import { useEffect, useRef, useState } from "react";
import { style } from "./StyleType";
import TmpIconCustom from "../TmpIconCustom/TmpIconCustom";
import { ReactComponent as Cancelar } from "../../../assets/icons/cancelar.svg";
import { ReactComponent as IconInfo } from "../../../assets/icons/info.svg";
import { ReactComponent as IconError } from "../../../assets/icons/erro.svg";

import { FormControlInput, FormControl, Helper, Label2, OptionsList, RemoverItemStyledIcon, Select, AlignContentCenter, WidhtControlInput, FormControlTagsInput, TagControl, TagLabel, InputSearch } from "./Style";
import Chevron from "./Chevron";
import OptionItem from "../../../models/OptionItem";
import SelectHelper from "../../../helpers/Selects/SelectHelper";
import TmpListItemCustom from "../TmpListItemCustom/TmpListItemCustom";

interface TmpInputSelectMultiCustomProps {
    id: string;
    label: string;
    name: string;
    placeholder: string;
    value: any;
    helperIcon?: "info" | "error";
    helperText?: string;
    itens: OptionItem[];
    error?: boolean;
    disabled?: boolean;
    onChange: (e: any) => void;
    onBlur?: (e: any) => void;
}


export default function TmpInputSelectMultiCustom(props: TmpInputSelectMultiCustomProps) {

    const [_inputOpened, setInputOpened] = useState(false);
    const [_optionsSelected, setOptionsSelected] = useState<OptionItem[]>([]);
    const [_textSearch, setTextSearch] = useState<string>();
    const [_itensAux, setItensAux] = useState<OptionItem[]>([]);
    const [_itens, setItens] = useState<OptionItem[]>(props.itens);

    const ref = useRef<HTMLInputElement>(null);
    const refInput = useRef<HTMLInputElement>(null);
    const refFormControl = useRef<HTMLInputElement>(null);

    const labelId = `${props.id}-label`;

    useEffect(() => {

        if (props.value && _optionsSelected.length === 0) {
            setOptionsSelected(props.value);
        }
// eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.value]);

    useEffect(() => {
        if (_itensAux === null || _itensAux?.length === 0) {
            setItensAux(props.itens);

            let newListWithoutSelecteds = SelectHelper.RemoveOptions(_optionsSelected, props.itens);
            setItens(newListWithoutSelecteds);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.itens, _itensAux]);

  
    const handleClickOutside = (event: any) => {
        if (ref.current && !ref.current.contains(event.target) && !refInput.current?.contains(event.target) && !refFormControl.current?.contains(event.target)) {
            setInputOpened(false);
        }
    };

    const convertToDefEventPara = (name: string, value: any) => ({
        target: {
            name, value
        }
    })

    useEffect(() => {
        document.addEventListener("click", handleClickOutside, true);
        return () => {
            document.removeEventListener("click", handleClickOutside, true);
        };
    });

    const _handleClick = () => {
        if (props.disabled) return;
        setInputOpened(!_inputOpened);
    };

    const _handleSelectOption = (item: any) => {
        convertToDefEventPara(props.name, item);
        _optionsSelected.push(item);
        setOptionsSelected(_optionsSelected);

        setTextSearch("");
        let newListWithoutSelecteds = SelectHelper.RemoveOptions(_optionsSelected, _itensAux);
        setItens(newListWithoutSelecteds);
        props.onChange(convertToDefEventPara(props.name, _optionsSelected))
    };

    const handleListItemKeyDown = (event: any, index: number) => {
        switch (event.key) {
            case "Tab":
                setInputOpened(false);
                break;

            case "Escape":
                event.preventDefault();
                setInputOpened(false);
                break;

            case "Enter":
                setInputOpened(false);
                _handleSelectOption(_itens[index]);
                break;

            default:
                break;
        }
    };

    const handleInputChange = (e: any) => {
        setTextSearch(e.target.value);
        setInputOpened(true);
        var listWithoutSelected = SelectHelper.RemoveOptions(_optionsSelected, _itensAux);
        setItens(SelectHelper.FilterOptions(e.target.value, listWithoutSelected));
    };

    //OBS: Método usando apenas para renderizar a mensagem de erro ao passar pelo campo. A seleção do campo dispara o evento de OnChange (handleAutocompleteChange)
    const handleOnBlurChange = (newValue: any) => {
        if (props.onBlur && newValue.target.value === "") {
            props.onBlur(convertToDefEventPara(props.name, _optionsSelected))
            // setValue(newValue.target.value)
        }
    };

    const handleRemoveItem = (event: any, item: OptionItem) => {
        let newOptions = SelectHelper.RemoveOptionsFromValue(item.Value, _optionsSelected);
        setOptionsSelected(newOptions);
        props.onChange(convertToDefEventPara(props.name, _optionsSelected))
        setItens(SelectHelper.RemoveOptions(newOptions, _itensAux));
        setInputOpened(false);
        event.stopPropagation();
    };

    const handleRemoveAllItem = (event: any) => {
        setOptionsSelected([]);
        props.onChange(convertToDefEventPara(props.name, []))
        setItens(_itensAux);
        setInputOpened(false);
        event.stopPropagation();
    };

    // Passing style props to styled component
    FormControl.defaultProps = style;
    Label2.defaultProps = style;
    Select.defaultProps = style;
    OptionsList.defaultProps = style;
    Helper.defaultProps = style;

    return (
        <>

            <FormControl
                actived={_inputOpened}
                onClick={_handleClick}
                onBlur={handleOnBlurChange}
                ref={refFormControl}
                error={props.error ? true : false}
                selected={true}
                disabled={props.disabled ? true : false}>
                <Label2 htmlFor={props.id} id={labelId} className="tmp-select__label">
                    {props.label}
                </Label2>
                <FormControlInput>
                    <AlignContentCenter>
                        <WidhtControlInput>
                            <FormControlTagsInput >

                                {_optionsSelected !== null && _optionsSelected.length > 0 &&
                                    _optionsSelected.map((item: OptionItem) => (
                                        <TagControl>
                                            <TagLabel>{item.Text}</TagLabel>
                                            <Cancelar onClick={(event) => handleRemoveItem(event, item)} />
                                        </TagControl>
                                    ))
                                }

                                <InputSearch autoComplete="off" ref={refInput} onChange={handleInputChange} value={_textSearch} name={`input-${props.name}`} placeholder="Digite os idiomas que você domina" type="text" />
                            </FormControlTagsInput>
                        </WidhtControlInput>
                        {_optionsSelected !== null && _optionsSelected.length > 0 &&
                            <div style={{ display: "flex" }}>
                                <RemoverItemStyledIcon onClick={(event) => handleRemoveAllItem(event)} />
                            </div>
                        }
                        <div style={{ display: "flex", cursor: "pointer" }}>
                            <TmpIconCustom size="sm" icon={<Chevron />} />
                        </div>
                    </AlignContentCenter>
                </FormControlInput>
                <Select data-testid="select" ref={ref}>
                    <OptionsList
                        id={props.id}
                        selected={-1}
                        actived={_inputOpened}
                        disabled={props.disabled ? true : false}
                        role="listbox"
                        aria-labelledby={labelId}>

                        {_itens.map((item, index) => (
                            <TmpListItemCustom
                                id={`${props.id}-${index}`}
                                key={index}
                                label={item.Text}
                                role="option"
                                tabIndex={index === 0 ? 0 : -1}
                                handleClick={() => _handleSelectOption(item)}
                                keyDown={(e: any) => { handleListItemKeyDown(e, index); }}
                            />
                        ))}

                        {_itens.length === 0 &&
                            <TmpListItemCustom
                                id={`-1-not-fount-${props.id}`}
                                key={-1}
                                label={"Resultado não encontrado"}
                                role="option"
                            />
                        }
                    </OptionsList>
                </Select>
                <Helper >
                    {props.helperIcon === "error" && props.error &&
                        <span className="icon">
                            <TmpIconCustom size="sm" icon={<IconError />} />
                        </span>
                    }
                    {props.helperIcon === "info" &&
                        <span className="icon">
                            <TmpIconCustom size="sm" icon={<IconInfo />} />
                        </span>
                    }
                    {props.helperText}

                </Helper>
            </FormControl>
        </>
    );
}
